<script>
    import { onMount } from "svelte";

    import PieChart from "../../../Components/Charts/PieChart.svelte";

    import { getRatioPercentageValue } from "../../../Utils/utilFunctions.svelte";

    export let encounters = {};

    let chartData = [];
    let chartLabels = [];

    let parsingData = true;
    let chartColors = [
        "rgba(251, 60, 186, 0.8)",
        "rgba(251, 212, 8, 1)",
        "rgba(7, 208, 3, 1)",
        "rgba(20, 184, 194, 1)",
        "rgba(97, 20, 194, 1)",
        "rgba(20, 90, 194, 1)",
        "rgba(30, 40, 130, 1)",
    ];

    onMount(() => {
        if (encounters) {
            const entries = Object.entries(encounters);

            let sumInsurances = 0;

            for (const [key, value] of entries) {
                sumInsurances += value;
            }

            for (const [key, value] of entries) {
                chartLabels = [...chartLabels, key];
                chartData = [
                    ...chartData,
                    getRatioPercentageValue(value, sumInsurances),
                ];
            }

            parsingData = false;
        }
    });
</script>

<div class="flex-1 flex flex-col p-6">
    {#if parsingData}
        <div class="flex-1 items-center text-center">Parsing chart data</div>
    {:else if !encounters}
        <div class="flex-1 items-center text-center">Nothing to display</div>
    {:else}
        <PieChart
            isResponsive={false}
            width="50"
            height="150px"
            backgroundColorArr={chartColors}
            {chartData}
            labels={chartLabels}
        />
    {/if}
</div>

<style>
</style>
